import { Component, EventEmitter, Input, Output } from '@angular/core';

export type PresetTone = 'neutral' | 'success' | 'warning' | 'primary';

export interface PresetFilter {
    id: string;
    label: string;
    /** Classe Font Awesome 4, es. 'fa-check-circle'. */
    icon: string;
    tone: PresetTone;
    description?: string;
}

/** Barra di "chip" per i filtri predefiniti: un clic imposta colonne e filtri della schermata. */
@Component({
    selector: 'app-preset-filters',
    templateUrl: './preset-filters.component.html',
    styleUrls: ['./preset-filters.component.css']
})
export class PresetFiltersComponent {
    @Input() presets: PresetFilter[] = [];
    @Input() activeId: string | null = null;
    @Input() counts: { [id: string]: number } = {};
    @Output() selected = new EventEmitter<string>();

    select(id: string): void {
        this.selected.emit(id);
    }

    trackById(_: number, preset: PresetFilter): string {
        return preset.id;
    }
}
